import React from 'react';
import notFoundImg from '../../images/page-not-found.PNG';

const NoPathFound = () => {
  return (
    <div className="row no-match-container">
      <div className="large-4 medium-4 columns icon-content">
        <img style={{ height: '250px' }} src={notFoundImg} alt="page" />
      </div>
      <div className="large-8 medium-8 columns text-content">
        <div className="first-line">Ooops... Error 404</div>
        <div className="second-line">We are sorry, but the page you are looking for does not exist.</div>
        <div className="third-line">
          <span>Please check entered address and try again.</span>
        </div>
      </div>
    </div>
  );
};

export default NoPathFound;
